import styled from '@emotion/styled';
import { mq } from '@hrworks/design-system';
import { SidebarToggleStyles } from '@hrworks/sui-core/ClassicLayout';

const SidebarToggle = styled(SidebarToggleStyles.SidebarToggle)({
  display: 'none',
  [mq.isSmallDevice]: {
    display: 'inline-flex',
  },
});

export const S = {
  SidebarToggle,
} as const;
